import { IApplicationState } from '@spinwise/spinwise-core';
import { useSelector } from 'react-redux';

const useGameLockCheck = () => {
  const { auth } = useSelector((store: IApplicationState) => store.authReducer);
  const { info } = useSelector((store: IApplicationState) => store.accountReducer);

  return allowBonus => {
    if (info?.activeBonus?.data?.ignore_game_restriction === 'yes') {
      return false;
    }

    const isGameLockedByBonus =
      auth?.success && info?.activeBonus !== null && !allowBonus && info?.isMonetaryActivityEnabled;

    return isGameLockedByBonus;
  };
};

export default useGameLockCheck;
